import { render, staticRenderFns } from "./WorldViewsPage.vue?vue&type=template&id=9413a5c0&scoped=true"
import script from "./WorldViewsPage.vue?vue&type=script&lang=ts"
export * from "./WorldViewsPage.vue?vue&type=script&lang=ts"
import style0 from "./WorldViewsPage.vue?vue&type=style&index=0&id=9413a5c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9413a5c0",
  null
  
)

export default component.exports